import {
  FaRing, FaGlassCheers, FaBirthdayCake, FaBriefcase,
  FaUtensils, FaUsers,
} from "react-icons/fa";

// ⭐ EDIT THIS — match hall names/capacities with your old banquet.html page
export const banquetData = [
  {
    id: 1,
    name: "Grand Banquet Hall",
    image: "/images/Banquet/Hall-1.jpg",
    capacity: "Up to 500 Guests",
    area: "6,000 sq.ft",
    short: "Our largest pillar-less hall with elegant interiors, royal chandeliers and a grand stage — perfect for weddings and big receptions.",
    features: ["Fully Air Conditioned", "Pillar-Less Hall", "Stage & Mandap Setup", "DJ & Lighting", "In-House Catering", "Power Backup"],
  },
  {
    id: 2,
    name: "Royal Banquet Hall",
    image: "/images/Banquet/Hall-2.jpg",
    capacity: "Up to 250 Guests",
    area: "3,500 sq.ft",
    short: "A beautifully designed mid-size hall ideal for receptions, ring ceremonies, anniversaries and family celebrations.",
    features: ["Fully Air Conditioned", "Elegant Décor", "Sound System", "Projector & Screen", "Catering Support", "Valet Parking"],
  },
  {
    id: 3,
    name: "Conference / Party Hall",
    image: "/images/Banquet/Hall-3.jpg",
    capacity: "Up to 120 Guests",
    area: "2,000 sq.ft",
    short: "A modern AC hall for corporate meetings, seminars, training sessions, birthdays and intimate gatherings.",
    features: ["Fully Air Conditioned", "Projector & Screen", "Whiteboard & Podium", "High-Speed Wi-Fi", "Tea / Coffee Service", "Flexible Seating"],
  },
];

// Seating arrangements supported
export const seatingStyles = [
  { style: "Theater Style", capacity: "Up to 500" },
  { style: "Round Table", capacity: "Up to 300" },
  { style: "U-Shape", capacity: "Up to 80" },
  { style: "Cluster / Group", capacity: "Up to 200" },
];

// Occasions hosted in the halls
export const hallOccasions = [
  { icon: FaRing, title: "Weddings" },
  { icon: FaGlassCheers, title: "Receptions" },
  { icon: FaUsers, title: "Ring Ceremonies" },
  { icon: FaBirthdayCake, title: "Birthday Parties" },
  { icon: FaBriefcase, title: "Corporate Meetings" },
  { icon: FaUtensils, title: "Food & Catering Events" },
];